import { Injectable } from '@angular/core';
import type { StoragePort } from './storage.port';

@Injectable({ providedIn: 'root' })
export class LocalStoragePort implements StoragePort {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
